import { noop } from 'lodash-es';
import { forwardRef } from 'react';

export const VideoTab = forwardRef(
  (
    {
      onClick,
      onKeyDown,
      active,
      id,
      children,
      tabIndex,
      disabled = false,
      'aria-controls': ariaControls,
      'data-e2e': dataE2e,
    },
    ref
  ) => {
    const activeClass = active ? ' ct-video-tabs__nav-tab--active' : '';

    return (
      <button
        ref={ref}
        id={id}
        type="button"
        role="tab"
        disabled={disabled}
        aria-selected={active}
        aria-controls={ariaControls}
        tabIndex={tabIndex}
        data-e2e={dataE2e}
        className={`ct-video-tabs__nav-tab${activeClass}`}
        onClick={disabled ? noop : onClick}
        onKeyDown={disabled ? noop : onKeyDown}
      >
        {children}
      </button>
    );
  }
);
